import { Box, Typography, useTheme, Button } from "@mui/material";
import { Line } from "react-chartjs-2";

import { useAppSelector } from "~/app/store";
import useWarehouseResponseTimes from "~/hooks/useWarehouseResponseTimes";

import { selectWorkstationAutostoreGridId } from "~/redux/selectors/workstationsSelectors";
import "chart.js/auto";

const WarehouseResponseChart = () => {
  const theme = useTheme();

  const autostoreGridId =
    useAppSelector(selectWorkstationAutostoreGridId) || "";

  const {
    responseTimes,
    averageResponseTime,
    isRunning,
    toggleRunning,
    clearData
  } = useWarehouseResponseTimes(1000, 600);

  const chartData = {
    labels: responseTimes.map((_, index) => index + 1),
    datasets: [
      {
        label: "Response Time (ms)",
        data: responseTimes,
        fill: false,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main
      }
    ]
  };

  const chartOptions = { maintainAspectRatio: false, responsive: true };

  return (
    <Box
      sx={{
        maxWidth: "400px",
        padding: "10px",
        backgroundColor: theme.palette.background.gray,
        border: "1px solid",
        borderColor: theme.palette.border.main,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start"
      }}
    >
      {autostoreGridId && (
        <>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Connectivity Test
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Average Response Time: {averageResponseTime} ms
          </Typography>
          <Box sx={{ width: "100%", height: "150px" }}>
            <Line data={chartData} options={chartOptions} />
          </Box>
          <Box sx={{ mt: 2, width: "100%", display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              onClick={toggleRunning}
              sx={{
                backgroundColor: isRunning
                  ? theme.palette.primary.dark
                  : theme.palette.primary.main,
                color: theme.palette.common.white
              }}
            >
              {isRunning ? "Stop Test" : "Start Test"}
            </Button>
            <Button
              variant="subtle"
              onClick={clearData}
              disabled={responseTimes.length === 0}
            >
              Clear Data
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default WarehouseResponseChart;
